import React from 'react';

import styled from 'styled-components';

import Money from '@components/Gui/Money';

const AmountDetailsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    font-size: ${(props) => props.theme.FontSizeSm};
`;

const renderTransactionAgencyFee = (row) => {
    const agencyFeeStatement = row.ClientStatements.find((statement) => statement.isCommission);
    return agencyFeeStatement ? `${agencyFeeStatement.TransactionPerc}% ag. fee` : '';
};

const renderTransactionAdvance = (row) => {
    const advanceStatement = row.ClientStatements.find((statement) => statement.isClientAdvance);
    return advanceStatement ? `${advanceStatement.Amount} advance` : '';
};

const renderTransactionCommission = (row) => {
    const commissionStatement = row.ModelStatements.find((statement) => statement.isCommission);
    return commissionStatement ? `${commissionStatement.TransactionPerc}% comm. on model` : '';
};

const ProjectSummaryAmountCell = ({
    row,
    isExpanded = false,
    showAgencyFee = false,
    showAgencyCommission = false,
    showAdvance = false,
    highlightCurrency = false,
    className = 'transaction-right',
}) => {
    const showQuantity = row.Quantity !== 1 || !['Flat', 'Units'].includes(row.TypeQuantity);

    return (
        <div className={className}>
            <div className="transaction-fee">
                {isExpanded && showQuantity && (
                    <AmountDetailsWrapper>
                        <Money amount={row.SingleFee} currency={row.Currency} />
                        <span>
                            x {row.Quantity} {row.TypeQuantity}
                        </span>
                    </AmountDetailsWrapper>
                )}
                <div className="total-fee">
                    <Money highlightCurrency={highlightCurrency} amount={row.TotalFee} currency={row.Currency} />
                </div>
                {isExpanded && row.Family === 'JobFee' && (
                    <>
                        <small>
                            {showAgencyFee && renderTransactionAgencyFee(row)}
                            {showAgencyCommission && (
                                <>
                                    <br />
                                    {renderTransactionCommission(row)}
                                </>
                            )}
                        </small>
                        {showAdvance && <small>{renderTransactionAdvance(row)}</small>}
                    </>
                )}
            </div>
        </div>
    );
};

export default ProjectSummaryAmountCell;
